import { ScanLine, ShoppingBasket, Sun, Heart, Wrench, Users } from "lucide-react";

const FEATURES = [
  {
    icon: ScanLine,
    title: "AI pantry scanning",
    text: "Snap a photo of your shelf and Domaya catalogues every item for you — no typing, no fuss.",
    tone: "bg-[var(--sage-light)] text-[var(--olive-deep)]",
    span: "sm:col-span-2",
  },
  {
    icon: Sun,
    title: "Today, at a glance",
    text: "One gentle daily view of what needs your attention — nothing more.",
    tone: "bg-[var(--peach)] text-[var(--terracotta)]",
  },
  {
    icon: ShoppingBasket,
    title: "Smart shopping lists",
    text: "Lists that build themselves from what's running low in your pantry.",
    tone: "bg-[var(--peach)] text-[var(--terracotta)]",
  },
  {
    icon: Wrench,
    title: "Home maintenance vault",
    text: "Appliances, warranties and service dates, all remembered for you so nothing slips.",
    tone: "bg-[var(--sage-light)] text-[var(--olive-deep)]",
    span: "sm:col-span-2",
  },
  {
    icon: Heart,
    title: "Care & routines",
    text: "Keep notes and routines for the people, pets and plants you look after.",
    tone: "bg-[var(--sage-light)] text-[var(--olive-deep)]",
  },
  {
    icon: Users,
    title: "Share the load",
    text: "Invite your household, assign tasks and celebrate the week's top helper.",
    tone: "bg-[var(--peach)] text-[var(--terracotta)]",
  },
];

export const Features = () => (
  <section id="features" className="bg-[var(--paper)] py-24 lg:py-32">
    <div className="mx-auto max-w-6xl px-6">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--terracotta)]">
        What Domaya does
      </p>
      <h2 className="mt-4 max-w-2xl font-display text-4xl font-semibold leading-tight tracking-tight text-[var(--ink)] sm:text-5xl">
        Everything a home needs, nothing it doesn't.
      </h2>

      <div className="mt-14 grid gap-5 sm:grid-cols-3" data-testid="features-grid">
        {FEATURES.map(({ icon: Icon, title, text, tone, span = "" }) => (
          <div
            key={title}
            data-testid={`feature-card-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className={`group rounded-3xl border border-[#efe5d8] bg-[var(--cream)] p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(46,42,36,0.25)] ${span}`}
          >
            <div className={`inline-flex rounded-2xl p-3 ${tone}`}>
              <Icon className="h-6 w-6" strokeWidth={1.8} />
            </div>
            <h3 className="mt-5 text-lg font-semibold text-[var(--ink)]">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[var(--ink-soft)]">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
